<template>
    <SoliAvatarBtn
        v-if="billingUser || purchaseOption"
        @click="$emit('input', $event)"
        :title="purchaseOption?.name"
        icon="wallet"
        :subtitleBottom="`Paid for by ${billingUser?.name}`"
        blue
    >
    </SoliAvatarBtn>
</template>

<script>
export default {
    props: {
        billingUser: {
            type: Object,
            default: null,
        },
        purchaseOption: {
            type: Object,
            default: null,
        },
    },
    computed: {},
};
</script>

<style></style>
